const VisibilityWrapper = ({ children, isVisible }) =>
  isVisible ? children : null;

export default VisibilityWrapper;
